import { c as _c } from "react/compiler-runtime";
import { IcoPlusSmall16 } from '@onefootprint/icons';
import { Form, LinkButton, TextInput } from '@onefootprint/ui';
import { FormProvider, useFieldArray, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { FormData, StepProps } from '@/pages/developers/vault-proxy/pages/list/vault-proxy.types';
import FormGrid from '../form-grid';
const defaultHeader = {
  name: '',
  value: '',
  secret: false
};
const CustomHeaderValues = t0 => {
  const $ = _c(43);
  const {
    id,
    onSubmit,
    values
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "create.form.customHeader"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("vault-proxy", t1);
  let t2;
  if ($[1] !== values.headers) {
    t2 = values.headers.length ? values.headers : [defaultHeader];
    $[1] = values.headers;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = {
      defaultValues: {
        headers: t2
      }
    };
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const form = useForm(t3);
  let t4;
  if ($[5] !== form.control) {
    t4 = {
      control: form.control,
      name: "headers",
      keyName: "fieldId"
    };
    $[5] = form.control;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    fields,
    append,
    remove
  } = useFieldArray(t4);
  let t5;
  if ($[7] !== append) {
    t5 = () => {
      append(defaultHeader);
    };
    $[7] = append;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const handleAdd = t5;
  let t6;
  if ($[9] !== remove) {
    t6 = index => () => {
      remove(index);
    };
    $[9] = remove;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const handleRemove = t6;
  let t7;
  if ($[11] !== form || $[12] !== onSubmit) {
    t7 = form.handleSubmit(onSubmit);
    $[11] = form;
    $[12] = onSubmit;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t) {
    t8 = t(_temp);
    $[14] = t;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <p className="text-label-2 text-primary mb-4 fp-text">{t8}</p>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== fields || $[19] !== form || $[20] !== handleRemove || $[21] !== t) {
    let t11;
    if ($[23] !== form || $[24] !== handleRemove || $[25] !== t) {
      t11 = (field, index_0) => <div key={field.fieldId}><input type="hidden" {...form.register(`headers.${index_0}.id`)} /><div className="mb-4"><div className="grid grid-cols-1 sm:grid-cols-2 gap-4"><TextInput size="compact" autoFocus={true} label={t(_temp2)} placeholder={t(_temp3)} {...form.register(`headers.${index_0}.name`)} /><TextInput size="compact" label={t(_temp4)} placeholder={field.id ? t(_temp5) : t(_temp6)} {...form.register(`headers.${index_0}.value`)} /></div></div><div className="flex items-center justify-between"><Form.Checkbox name={`headers.${index_0}.secret`} label={t(_temp7)} /><LinkButton onClick={handleRemove(index_0)} destructive={true}>{t(_temp8)}</LinkButton></div></div>;
      $[23] = form;
      $[24] = handleRemove;
      $[25] = t;
      $[26] = t11;
    } else {
      t11 = $[26];
    }
    t10 = fields.map(t11);
    $[18] = fields;
    $[19] = form;
    $[20] = handleRemove;
    $[21] = t;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[27] !== t10) {
    t11 = <FormGrid>{t10}</FormGrid>;
    $[27] = t10;
    $[28] = t11;
  } else {
    t11 = $[28];
  }
  let t12;
  if ($[29] !== t) {
    t12 = t(_temp9);
    $[29] = t;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== handleAdd || $[32] !== t12) {
    t13 = <LinkButton iconComponent={IcoPlusSmall16} iconPosition="left" onClick={handleAdd}>{t12}</LinkButton>;
    $[31] = handleAdd;
    $[32] = t12;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  let t14;
  if ($[34] !== id || $[35] !== t11 || $[36] !== t13 || $[37] !== t7 || $[38] !== t9) {
    t14 = <form id={id} onSubmit={t7}>{t9}{t11}{t13}</form>;
    $[34] = id;
    $[35] = t11;
    $[36] = t13;
    $[37] = t7;
    $[38] = t9;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== form || $[41] !== t14) {
    t15 = <FormProvider {...form}>{t14}</FormProvider>;
    $[40] = form;
    $[41] = t14;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  return t15;
};
export default CustomHeaderValues;
function _temp($) {
  return $.title;
}
function _temp2($_0) {
  return $_0.name.label;
}
function _temp3($_1) {
  return $_1.name.placeholder;
}
function _temp4($_2) {
  return $_2.value.label;
}
function _temp5($_3) {
  return $_3.value.existingSecretPlaceholder;
}
function _temp6($_4) {
  return $_4.value.placeholder;
}
function _temp7($_5) {
  return $_5.secret.label;
}
function _temp8($_6) {
  return $_6.remove;
}
function _temp9($_7) {
  return $_7.addMore;
}